<template>
  <div class="login_form_invitation">
    <div class="grid grid--rev" id="invitation-form">
      <div class="grid__cell col12-of-12">
        <h1 class="fw-bold pb-xs">Join PartnerPage</h1>
        <p class="fc-darker fs-xs pb-md">
          Already have a PartnerPage.io account?
          <a :href="loginLink" class="fc-purple">Sign in here</a>
        </p>
        <form @submit.prevent="submitForm">
          <label class="is-required">
            First Name
            <input
              data-hj-allow
              type="text"
              name="first_name"
              required
              placeholder="Bob"
              id="id_first_name"
              maxlength="50"
              :value="firstName"
              @change="firstName = $event.target.value"
            />
          </label>
          <label class="is-required">
            Last Name
            <input
              data-hj-allow
              type="text"
              name="last_name"
              required
              placeholder="Doe"
              id="id_last_name"
              maxlength="50"
              :value="lastName"
              @change="lastName = $event.target.value"
            />
          </label>
          <label class="is-required">
            {{ companyInput.title }}
            <input
              data-hj-allow
              type="text"
              :name="companyInput.name"
              required
              placeholder="Acme, Inc."
              :id="companyInput.id"
              maxlength="255"
              :value="companyName"
              @change="companyName = $event.target.value"
            />
          </label>
          <label class="is-required">
            Email Address
            <input
              type="email"
              name="email"
              required
              placeholder="example@email.com"
              id="id_email"
              :value="email"
              @change="email = $event.target.value"
            />
          </label>
          <label class="is-required">
            Password
            <input
              type="password"
              name="password"
              required
              id="id_password"
              v-model="password"
            />
          </label>
          <Button
            type="submit"
            bSize="expanded"
            :class="loading ? 'is-disabled is-loading' : ''"
            style="text-transform: none !important"
          >
            Join PartnerPage
          </Button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/DesignSystem/Button';

export default {
  components: {
    Button,
  },
  props: {
    companyInput: Object,
    invite: Object,
    vendorToAgency: Boolean,
    agencyToVendor: Boolean,
    getListed: Boolean,
    agency: Boolean,
    vendor: Boolean,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    loginLink() {
      if (this.getListed && this.vendor)
        return `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/vendor/get-listed/${this.$store.getters.directory.id}/${this.$store.getters.directory.vendorData.name}`;
      if (this.getListed && this.agency)
        return `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/agency/get-listed/${this.$store.getters.directory.vendor}/${this.$store.getters.directory.vendorData.name}`;
      if (this.vendorToAgency) {
        return `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/add_partner/${this.invite.inviteId}/${this.invite.vendorId}/${this.invite.vendorName}`;
      }
      if (this.agencyToVendor) {
        return `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/create_partner/${this.invite.inviteId}/${this.invite.resellerId}/${this.invite.resellerName}/agency`;
      }
      return `${process.env.VUE_APP_PROTOCOL_PREFIX}://${process.env.VUE_APP_ADMIN_SUBDOMAIN}.${process.env.VUE_APP_ROOT_CLIENT}/create_partner/${this.invite.inviteId}/${this.invite.vendorId}/${this.invite.vendorName}/vendor`;
    },
  },
  watch: {
    invite: {
      handler(val) {
        this.firstName = val.firstName;
        this.lastName = val.lastName;
        this.email = val.email;
        this.companyName = val.company;
      },
      deep: true,
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      companyName: '',
      password: '',
    };
  },
  methods: {
    submitForm() {
      if (this.loading) return;
      const data = {
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        companyName: this.companyName,
        password: this.password,
      };
      return this.$emit('submit-form', data);
    },
  },
};
</script>
